import { Modal } from "@joonapp/web-shared"

import ChildSurvey from "./ChildSurvey"
import Survey from "./Survey"
import SurveysOverview from "./SurveysOverview"
import useSurveysModalStore from "../store/useSurveysModalStore"

const SurveysModal = () => {
  const { isOpen, onClose, selectedSurvey, selectedChildSurveys } =
    useSurveysModalStore()

  return (
    <Modal
      animate
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "min(100vw, 600px)", height: "max(95dvh, 0px)" }}
    >
      {selectedSurvey ? (
        <Survey />
      ) : selectedChildSurveys.length > 0 ? (
        <ChildSurvey />
      ) : (
        <SurveysOverview />
      )}
    </Modal>
  )
}

export default SurveysModal
